import React from "react";
import LegalDocumentLayout from "./LegalDocumentLayout";

export default function RefundPolicy() {
  return (
    <LegalDocumentLayout title="Refunds, cancellations & rental deposits">
      <h2>Rental charges</h2>
      <p>
        The rental price, applicable taxes, delivery charges, and refundable security deposit, if any, are shown at
        checkout or confirmed before the booking is accepted.
      </p>

      <h2>Razorpay / online settlements</h2>
      <p>
        Approved refunds for online payments are sent to the original payment method. Banks and payment providers may take
        additional working days to show the credit after we process it.
      </p>

      <h2>Cancellations</h2>
      <p>
        Contact us as soon as possible to request a cancellation. Eligibility and the amount refunded depend on whether
        the garment has been reserved, altered, prepared, or dispatched. Customisation and delivery costs already incurred
        may be non-refundable.
      </p>

      <h2>Damage & security deposits</h2>
      <p>
        A refundable deposit is released after the garment and accessories are returned and inspected. Reasonable cleaning,
        repair, replacement, late-return, or missing-item costs may be deducted. We will explain any deduction applied.
      </p>

      <h2>Faulty garments</h2>
      <p>
        If you receive an incorrect or materially damaged garment, notify us promptly with your order details and photos.
        After verification, we may arrange a replacement, reschedule the rental, issue store credit, or provide an
        appropriate refund.
      </p>

      <h2>Grievances</h2>
      <p>
        For cancellation, refund, or deposit questions, contact gemboutiqueinquiries@gmail.com with your order number and
        registered contact details.
      </p>
    </LegalDocumentLayout>
  );
}
